/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-04-09 17:53:19
 */
import React, { useCallback } from 'react'
import { Checkbox } from 'antd'
import { Watermark } from '../typings'
import sensors, {
  parsePlaceValue,
  sensorsRole
} from '../../../../utils/sensors'
import { useAppSelector } from '../../../../app/hooks'
import { StopOutlined } from '@ant-design/icons'

interface IWatermarkItemProps {
  checkedWatermarks: string[]
  watermark: Watermark
  onCheck: (checkedWatermarks: string[]) => void
}

const WatermarkItem: React.FC<IWatermarkItemProps> = (props) => {
  const { watermark, checkedWatermarks, onCheck } = props
  const groupID = useAppSelector((state) => state.group.groupId)
  const myRole = useAppSelector((state) => state.group.myRole)
  const id = `${watermark.watermark_base_id}+${watermark.group_watermark_id}`
  const checked = checkedWatermarks.includes(id)
  const onCheckClick = useCallback(
    (e) => {
      if (!checked || e.target.checked) {
        sensors.track('web_click_pop_workgroup_filter_watermark', {
          clickItem: 'checkWatermark',
          pageType: parsePlaceValue(),
          groupID,
          role: sensorsRole(myRole)
        })
        onCheck([...checkedWatermarks, id])
      } else {
        onCheck(checkedWatermarks.filter((value) => value !== id))
      }
    },
    [checked, checkedWatermarks, id]
  )

  return (
    <div className="watermark">
      <WatermarkCover watermark={watermark} onClick={onCheckClick} />
      {/* 使用 watermark_base_id + group_watermark_id 结合，来唯一区分一个水印 */}
      <Checkbox checked={checked} onChange={onCheckClick} />
    </div>
  )
}

interface IWatermarkCoverProps {
  watermark: Watermark
  onClick: (e: any) => void
}

enum WatermarkType {
  Group = 1,
  Normal = 2,
  NoWatermark = 3
}

const WatermarkCover: React.FC<IWatermarkCoverProps> = (props) => {
  const { watermark, onClick } = props

  if (watermark.type === WatermarkType.Group) {
    return (
      <div className="group-watermark-cover" onClick={onClick}>
        <div className="title">{watermark.name}</div>
        <div className="time">最近使用：{watermark.time}</div>
      </div>
    )
  } else if (watermark.type === WatermarkType.Normal) {
    return (
      <div
        className="normal-watermark-cover"
        style={{
          backgroundImage: `url(${watermark.cover_image_url})`
        }}
        onClick={onClick}
      >
        <div className="time">最近使用：{watermark.time}</div>
      </div>
    )
  } else {
    return (
      <div className="no-watermark-cover" onClick={onClick}>
        <div className="title">
          <StopOutlined />
          &nbsp;无水印
        </div>
        <div className="time">最近使用：{watermark.time}</div>
      </div>
    )
  }
}

export default WatermarkItem
